import {
  FETCH_EXAM_RESULT,
  FETCH_EXAM_RESULT_SUCCESS,
  FETCH_EXAM_RESULT_FAILURE,
  SAVE_EXAM_RESULT,
  SAVE_EXAM_RESULT_SUCCESS,
  SAVE_EXAM_RESULT_FAILURE,
  DELETE_EXAM_RESULT,
  DELETE_EXAM_RESULT_SUCCESS,
  DELETE_EXAM_RESULT_FAILURE,
} from './actionTypes'

export const fetchExamResult = (examId, userId) => ({
  type: FETCH_EXAM_RESULT,
  payload: { examId, userId },
})

export const fetchExamResultSuccess = result => ({
  type: FETCH_EXAM_RESULT_SUCCESS,
  payload: { result },
})

export const fetchExamResultFailure = error => ({
  type: FETCH_EXAM_RESULT_FAILURE,
  payload: { error },
})

export const saveExamResult = (examId, userId, result) => ({
  type: SAVE_EXAM_RESULT,
  payload: { examId, userId, result },
})

export const saveExamResultSuccess = result => ({
  type: SAVE_EXAM_RESULT_SUCCESS,
  payload: { result },
})

export const saveExamResultFailure = error => ({
  type: SAVE_EXAM_RESULT_FAILURE,
  payload: { error },
})

export const deleteExamResult = (examId, userId) => ({
  type: DELETE_EXAM_RESULT,
  payload: { examId, userId },
})

export const deleteExamResultSuccess = () => ({
  type: DELETE_EXAM_RESULT_SUCCESS,
  payload: {},
})

export const deleteExamResultFailure = error => ({
  type: DELETE_EXAM_RESULT_FAILURE,
  payload: { error },
})
